export const CHOOSE_DELIVERY_STRINGS = "replacement.chooseDelivery";
